/** Stable ids for recap / Gazette tone — must match allowlist in Cloud Function `generateGameRecap`. */

export const DEFAULT_RECAP_STYLE = 'classic';

export const RECAP_STYLE_OPTIONS = [
  { id: 'classic', label: 'Classic highlight reel' },
  { id: 'wire', label: 'Wire / AP (dry, tight)' },
  { id: 'hometownRadio', label: 'Hometown radio (warm, conversational)' },
  { id: 'notebook', label: 'Locker room notebook (staccato)' },
  { id: 'tabloidSafe', label: 'Tabloid punch (big energy, still family-safe)' },
];

const ALLOWED = new Set(RECAP_STYLE_OPTIONS.map((o) => o.id));

export function normalizeRecapStyle(id) {
  return typeof id === 'string' && ALLOWED.has(id) ? id : DEFAULT_RECAP_STYLE;
}

export function recapStyleLabel(id) {
  const n = normalizeRecapStyle(id);
  return RECAP_STYLE_OPTIONS.find((o) => o.id === n)?.label ?? RECAP_STYLE_OPTIONS[0].label;
}
